import React, {Component} from 'react'

import Popup from '../Popup/index';

import Registry from '../../../registry/index';

class LoggedOutPopup extends Popup {
    constructor(props) {
        super(props);

        this.userClosable = false;
        this.showOverlay = true;
        this.afterClosePositionReset = false;
    }

    render() {
        let lang = Registry.get('locale');

        let reloginUrl = this.props.reloginUrl ? lang.path + this.props.reloginUrl : document.location.href;

        let className = 'popup popup-logged-out ' + this.state.visibility;

        return (
            <div className={className} ref={(ref) => this._ref = ref}>
                <p>{lang.logged_out}</p>
                <div className="buttons">
                    <a href={reloginUrl} className="popup-button">{lang.relogin}</a>
                </div>
             </div>
        )
    }
}

LoggedOutPopup.generateKey = function() { return 'logged-out-popup' };
LoggedOutPopup.mount = function(props, onMount) { return Popup.mount(LoggedOutPopup, props, onMount) };
LoggedOutPopup.open = function(props) {
    var id = LoggedOutPopup.generateKey(props);

    if (!Popup.popups[id]) {
        LoggedOutPopup.mount(props, () => Popup.popups[id].open());
    } else {
        Popup.popups[id].open()
    }
};

export default LoggedOutPopup;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/LoggedOutPopup/index.js